<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="导入SN号" width="500" @close="close">
      <el-upload
          v-model:file-list="fileList"
          class="upload-demo"
          :action="uploadExcel"
          :http-request="uploadExcelList"
          multiple
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :before-upload="handleBeforeUpload"
          :limit="5"
          :on-exceed="handleExceed"
      >
        <el-button type="primary">开始上传</el-button>
        <template #tip>
          <div class="el-upload__tip">
            xlsx/xls files with a size less than 10M.
          </div>
        </template>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
import {ElDialog, ElButton, ElUpload, ElMessage} from "element-plus";
import http, {uploadExcel} from "../utils/requset.js"
export default {
  name: "uploadFile",
  components:{ElDialog,ElButton,ElUpload},
  data(){
    return{
      dialogTableVisible:false,
      uploadExcel:'',
      fileList:[],
      extraParams: {
        uploadType: 'sn',
      }
    }
  },
  beforeMount(){
    this.uploadExcel = uploadExcel
  },
  methods:{
    handlePreview(uploadFile){
      console.log(uploadFile);
    },
    handleRemove(file, uploadFiles){
      console.log(file, uploadFiles)
    },
    beforeRemove(file, uploadFiles){
      console.log(file, uploadFiles)
    },
    handleExceed(files, uploadFiles){
      console.log(files, uploadFiles)
      ElMessage.error('最多一次上传5个文件');
    },
    handleBeforeUpload(file){
      if (!file.type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
          !file.type.match('application/vnd.ms-excel')) {
        ElMessage.error('上传文件只能是excel!');
        return false;
      }else if (file.size / 1024 / 1024 > 10) {
        ElMessage.error('文件上传大小不超过10M!')
        return false
      }
    },
    uploadExcelList(param){
      const formData = new FormData();
      // 添加文件到表单数据中
      formData.append('file', param.file);
      // 添加额外的参数到表单数据中
      Object.keys(this.extraParams).forEach(key => {
        formData.append(key, this.extraParams[key]);
      });
      // 使用 axios 或其他 HTTP 客户端发送请求
      http.post(uploadExcel,formData, {}).then(res=>{
        console.log(res)
        this.fileList[this.fileList.length-1].status='success'
        console.log(this.fileList)
      }).catch(err=>{
        console.log(err)
      })
    },
    open(data){
      console.log(data)
      this.fileList = []
      this.dialogTableVisible = true;
    }
  }
}
</script>
<style scoped>

</style>